import React from 'react';
import App from './components/App';
import { AppContext } from './contexts';

var WidgetCustomization = function WidgetCustomization(_ref) {
  var chartSettings = _ref.chartSettings,
      widgetSettings = _ref.widgetSettings,
      onUpdateWidgetSettings = _ref.onUpdateWidgetSettings,
      _onUpdateChartSettings = _ref.onUpdateChartSettings,
      modalContainer = _ref.modalContainer,
      savedQueryName = _ref.savedQueryName,
      widgetType = _ref.widgetType,
      _ref$customizationSec = _ref.customizationSections,
      customizationSections = _ref$customizationSec === void 0 ? {} : _ref$customizationSec,
      pubSub = _ref.pubSub,
      onMenuItemChange = _ref.onMenuItemChange,
      activeMenuItem = _ref.activeMenuItem,
      analysisResult = _ref.analysisResult;
  return React.createElement(AppContext.Provider, {
    value: {
      modalContainer: modalContainer,
      pubSub: pubSub
    }
  }, React.createElement(App, {
    chart: chartSettings,
    widget: widgetSettings,
    widgetType: widgetType,
    savedQueryName: savedQueryName,
    customizationSections: customizationSections,
    analysisResult: analysisResult,
    onMenuItemChange: onMenuItemChange,
    activeMenuItem: activeMenuItem,
    onUpdateChartSettings: function onUpdateChartSettings(settings) {
      _onUpdateChartSettings(settings);
    },
    onUpdateWidgetSettings: onUpdateWidgetSettings
  }));
};

export default WidgetCustomization;